import {
    FGTypography,
    FGStack,
    FGToast,
    FGToastOptions,
    FGToastProps,
} from '@fg/design-system';

import {
    C_CHART_EXPORT_START_HEADLINE,
    C_CHART_EXPORT_START_INFO,
    C_CHART_EXPORT_ERROR,
} from '../../constants';

export type ToasterConfig = {
    generalToastTemplateProps: FGToastProps;
    options: FGToastOptions;
};

export const BASE_TOASTER_OPTIONS: Partial<FGToastOptions> = {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 5000,
};
export const exportStartToast: ToasterConfig = {
    generalToastTemplateProps: {
        content: (
            <FGStack direction="column" gap={2}>
                <FGTypography tag="label" variant="headline6">
                    {C_CHART_EXPORT_START_HEADLINE}
                </FGTypography>
                <FGTypography tag="label" variant="body4">
                    {C_CHART_EXPORT_START_INFO}
                </FGTypography>
            </FGStack>
        ),
        type: 'neutral',
    },
    options: {
        ...BASE_TOASTER_OPTIONS,
    },
};

export const exportErrorToast: ToasterConfig = {
    generalToastTemplateProps: {
        content: C_CHART_EXPORT_ERROR,
        type: 'error',
    },
    options: {
        ...BASE_TOASTER_OPTIONS,
    },
};

export const createExportStartToaster = () => {
    return FGToast(
        exportStartToast.generalToastTemplateProps,
        exportStartToast.options
    );
};

export const createExportErrorToaster = () => {
    return FGToast(
        exportErrorToast.generalToastTemplateProps,
        exportErrorToast.options
    );
};
